const NetherLandsLanguageMap = {
  guidenotupdated:
    'Deze gemeenschapsvertaling is nog niet bijgewerkt naar de nieuwste versie van Storybook. Help ons om het bij te werken door de wijzigingen in de Nederlandse gids voor deze vertaling toe te passen.',
  pullrequestmessage: 'Pull requests ze zijn welkom',
};

export default NetherLandsLanguageMap;
